import { Typography, useTheme } from "@mui/material";
import type { FC } from "react";

type Props = {
	text: string;
};

export const CalculatorNote: FC<Props> = ({ text }) => {
	const theme = useTheme();

	return (
		<Typography
			variant="body1"
			textAlign="center"
			px={theme.spacingTokens.lg}
			py={theme.spacingTokens.lg}
			display="block"
		>
			{text}
		</Typography>
	);
};
